import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AUTH_FEATURE_NAME, authReducer } from './auth.reducer';
import { AuthEffects } from './auth.effects';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(AUTH_FEATURE_NAME, authReducer), EffectsModule.forFeature([AuthEffects])],
})
export class StoreAuthModule {}
